/* tslint:disable: ordered-imports*/

import { NgModule } from '@angular/core';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FeatherModule } from 'angular-feather';

import { featherIcons } from './icons.feather';
import { fontAwesomeBrandsIcons } from './icons.font-awesome-brands';
import { fontAwesomeRegularIcons } from './icons.font-awesome-regular';
import { fontAwesomeSolidIcons } from './icons.font-awesome-solid';

@NgModule({
    imports: [FeatherModule.pick(featherIcons)],
    exports: [FeatherModule, FontAwesomeModule],
})
export class IconsModule {
    constructor(library: FaIconLibrary) {
        library.addIconPacks(fontAwesomeSolidIcons, fontAwesomeRegularIcons, fontAwesomeBrandsIcons);
    }
}
